var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-01-B",
    transform: "translate(-247.000000, -141.000000)",
    stroke: "#95C11F",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(232.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_logout",
    transform: "translate(16.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17833333,13.75 C2.96077318,17.9419045 7.44764243,20.2998853 11.911038,19.3903497 C16.3744336,18.480814 19.5808377,14.5551241 19.5808377,10 C19.5808377,5.44487594 16.3744336,1.51918597 11.911038,0.609650338 C7.44764243,-0.299885294 2.96077318,2.05809549 1.17833333,6.25",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10.4166667 13.3333333 13.75 10 10.4166667 6.66666667"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.75,
    y1: 10,
    x2: 0.416666667,
    y2: 10,
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.b002724f1d598cb9a2bf4919768d545a.svg";
export { ForwardRef as ReactComponent };